<template>
  <div class="column is-2 has-text-centered-desktop">
    <ws-permission-node
        :resources="['services/de/participants']"
        :actions="['read']"
        effect="display"
    >
      <router-link
          :to="`/demo-exams/${exam.guid}`"
          class="ws-button is-text"
      >
                      <span class="ws-button__text">
                         <ws-popover position="top">
                          <template class="popover-label">
                            <div class="participants">
                              <span class="has-text-primary ">{{
                                  $t("Участники: ")
                                }}</span>
                             <div class="has-text-primary">
                               <span style="color: #72AF48">{{resultsImported}}</span>
                               /
                               <span  :style="{'color': colorImportAndRating}">{{passedCount}}</span>
                               /
                               <span  :style="{'color': colorImportAndRating}">{{ratingsCount}}</span>
                             </div>
                            </div>

                          </template>

                          <div
                              slot="content"
                              class="popover"
                          >
                            <p class="popover__title">Подтвердить готовность к проведению ДЭ</p>
                            <div class="popover__item popover__item_success">
                               <ws-icon
                                   name="check-mark"
                                   color="#72AF48"
                                   width="16"
                                   height="16"
                               />
                              <p>“Сдавал” экзамен: {{resultsImported}} чел.</p>
                            </div>
                            <div class="popover__item"
                                 :style="{'color': colorImportAndRating}"
                            >
                               <ws-icon
                                   name="check-mark"
                                   :color="colorImportAndRating"
                                   width="16"
                                   height="16"
                               />
                              <p>“Загружены результаты”: {{passedCount}} чел.</p>
                            </div>
                            <div class="popover__item"
                                 :style="{'color': colorImportAndRating}"
                            >
                               <ws-icon
                                   name="check-mark"
                                   :color="colorImportAndRating"
                                   width="16"
                                   height="16"
                               />
                              <p>Выставлены оценки: {{ratingsCount}} чел.</p>
                            </div>
                          </div>
                        </ws-popover>

                        <span class="has-text-primary">
                          ({{ $t("план ")
                          }}{{ getCapacityOfParticipants }}).
                        </span>

                        <span class="has-text-primary"
                        >{{ $t("НОК: ")
                          }}{{ getNokParticipantsCount }}</span
                        >
                        <span class="has-text-primary">
                          ({{ $t("план ")
                          }}{{
                            getCapacityOfNokParticipants
                          }}).</span
                        >
                      </span>
      </router-link>
    </ws-permission-node>
  </div>
</template>

<script>
import WsPopover from '@/components/common/WsPopover.vue'
import { getAllParticipants, getPassedCount, getResultsImported } from '@/components/de/demo-exams/data/log-data'

const nullGuid = '00000000-0000-0000-0000-000000000000'
export default {
  name: 'WsFooterInfoItemList',
  components: {
    WsPopover
  },
  props: { exam: Object },
  computed: {
    getCapacityOfNokParticipants () {
      const groups = this.exam.shifts
        ? [...this.exam.shifts.map(item => item.groups || [])].flat()
        : []
      return groups.reduce(
        (count, group) =>
          group.independent_estimate_participants_number + count,
        0
      )
    },
    getNokParticipantsCount () {
      const participants = this.getParticipants(this.exam)
      return participants.reduce((count, participant) => {
        if (participant.files['de-participants-noc'].guid !== nullGuid) {
          return count++
        }
        return count
      }, 0)
    },
    getCapacityOfParticipants () {
      const groups = this.exam.shifts
        ? [...this.exam.shifts.map(item => item.groups || [])].flat()
        : []
      return groups.reduce((count, group) => group.student + count, 0)
    },
    resultsImported () {
      return getResultsImported(getAllParticipants(this.exam.shifts))
    },
    passedCount () {
      return getPassedCount(getAllParticipants(this.exam.shifts))
    },
    ratingsCount () {
      const participants = getAllParticipants(this.exam.shifts)
      const count = participants.filter((elem) => {
        return elem.status === 'passed' && elem.scaled_mark
      })
      return count.length
    },
    colorImportAndRating () {
      return this.resultsImported === this.ratingsCount ? '#72AF48' : '#EEA150'
    }
  },
  methods: {
    getParticipants (exam) {
      const groups = exam.shifts
        ? [...exam.shifts.map(item => item.groups || [])].flat()
        : []
      return groups.map(group => group.participants || []).flat()
    }
  }
}
</script>
<style lang="scss" scoped>
.popover{
  color: black;
  display: flex;
  flex-direction: column;
  gap: 4px;

  &__title{
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;
    margin-bottom: 6px;
  }

  &__item{
    display: flex;
    align-items: center;
    gap: 5px;

    &_success{
      color: #72AF48;
    }

    &_reject{
      color: #EEA150;
    }
  }

  &:hover{
    color: black;
  }
}
.participants{
  display: flex;
  align-items: center;
  gap: 3px;
  flex-wrap: wrap;
  justify-content: center;

  @media (max-width: 800px) {
    justify-content: flex-start;
  }
}
</style>
